"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const pluralize_1 = __importDefault(require("pluralize"));
const SongwriterCatalogBuilderToggle_1 = __importDefault(require("@Components/SongwriterCatalogBuilderToggle"));
const common_1 = require("@Const/common");
const mobx_react_1 = require("mobx-react");
const SongwriterMyWritersRow = (props) => {
    const { writer, onTitleClick, onWriterToggle, isChecked } = props;
    return (react_1.default.createElement("div", { className: 'songwriter-my-writer-table-row', key: writer.ipId },
        react_1.default.createElement(SongwriterCatalogBuilderToggle_1.default, { onClick: (isLinked) => {
                onWriterToggle(isLinked, Number(writer.ipId));
            }, internalLabel: isChecked ? 'Yes' : 'No', checked: isChecked }),
        react_1.default.createElement("div", { className: 'writer-data' },
            react_1.default.createElement("div", { className: 'writer-name-titles' },
                react_1.default.createElement("span", { className: 'writer-name' },
                    writer.name,
                    ":")),
            react_1.default.createElement("div", { className: 'writer-ipi' },
                react_1.default.createElement("span", null, "IPI:"),
                " ",
                writer.ipiNumber)),
        react_1.default.createElement("div", { className: (0, clsx_1.default)('writer-works', !!writer.worksCount && 'clickable'), onClick: () => !!writer.worksCount && onTitleClick(writer) },
            react_1.default.createElement("div", { className: 'writer-titles' },
                react_1.default.createElement("span", null, writer.worksCount),
                react_1.default.createElement("span", null, (0, pluralize_1.default)('Song', writer.worksCount))),
            react_1.default.createElement("img", { className: 'right-chevron', src: common_1.ICONS.chevron_right, alt: 'right chevron icon' }))));
};
exports.default = (0, mobx_react_1.observer)(SongwriterMyWritersRow);
